// src/api.ts

let API_BASE_URL: string = '';

const OBJECT_STORAGE_URL: string =
  'https://kr.object.ncloudstorage.com/us-image-storage';

export async function fetchApiConfig(): Promise<void> {
  console.log('NODE_ENV:', process.env.NODE_ENV);
  console.log('ENV API:', process.env.REACT_APP_API_BASE_URL);

  if (process.env.NODE_ENV === 'development') {
    const envApiUrl = process.env.REACT_APP_API_BASE_URL;
    
    if (!envApiUrl) {
      throw new Error(
        '[API CONFIG] DEV 환경인데 REACT_APP_API_BASE_URL이 없습니다. .env.development 파일을 확인하세요.'
      );
    }
    
    API_BASE_URL = envApiUrl;
    console.log('[API CONFIG] DEV:', API_BASE_URL);
    return;
  }

  try {
    const response = await fetch('/api/config/', { cache: 'no-store' });
    
    if (!response.ok) {
      throw new Error(`Config fetch failed: ${response.status}`);
    }
    
    const config: { API_BASE_URL: string } = await response.json();
    
    if (!config.API_BASE_URL) {
      throw new Error('API_BASE_URL missing in /api/config/');
    }
    
    API_BASE_URL = config.API_BASE_URL;
    console.log('[API CONFIG] PROD:', API_BASE_URL);
  } catch (error) {
    console.error('[API CONFIG] FAILED:', error);
    throw error;
  }
}

export function getApiUrl(path: string): string {
  if (!API_BASE_URL) {
    throw new Error(
      '[API CONFIG] API_BASE_URL이 초기화되지 않았습니다. fetchApiConfig()를 먼저 호출하세요.'
    );
  }
  return `${API_BASE_URL}${path}`;
}

export function getStaticUrl(path: string): string {
  const filename = path.split('/').pop();
  return `${OBJECT_STORAGE_URL}/${filename}`;
}

export function getMediaUrl(path: string): string {
  const cleanPath = path.startsWith('/') ? path.substring(1) : path;
  return `${OBJECT_STORAGE_URL}/media/${cleanPath}`;
}

export async function fetchWithAuth(url: string, options: RequestInit = {}): Promise<Response> {
  const token = localStorage.getItem('access_token')
  const res = await fetch(url, {
    ...options,
    headers: {
      ...options.headers,
      Authorization: `Bearer ${token}`,
    },
  })

  if (res.status === 401) {
    localStorage.removeItem('access_token')
    window.location.href = '/auth/login'
    throw new Error('Unauthorized')
  }

  return res
}